"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// calculates the total price for the cruise
function priceDiffers(_state, getters) {
    var cabinPriceDiffer = getters['cabins/currentPriceDiffer'];
    var insurancePriceDiffer = getters['insurance/currentPriceDiffer'];
    var flightPriceDiffers = null;
    if (getters['transportAir/currentPriceDiffer']) {
        flightPriceDiffers = {
            type: 'AIR',
            price: getters['transportAir/currentPriceDiffer'],
            priceOld: getters['transportAir/selectedConnPrice']
        };
    }
    var flexFlightPriceDiffers = null;
    if (getters['transportFlexFlights/currentPriceDiffer']) {
        flexFlightPriceDiffers = {
            type: 'FLX',
            price: getters['transportFlexFlights/currentPriceDiffer'],
            priceOld: getters['transportFlexFlights/selectedConnPrice']
        };
    }
    var priceDiffers = {
        cabin: cabinPriceDiffer,
        flight: flightPriceDiffers || flexFlightPriceDiffers,
        insurance: insurancePriceDiffer
    };
    // return price differs of this item
    return priceDiffers;
}
exports.default = priceDiffers;
//# sourceMappingURL=price_differs.js.map